<template>
    <div class="cate-manage">
        <el-button type="primary" size="mini" icon="el-icon-back" @click="$router.back()">返回上一级</el-button>
        <el-divider content-position="left">分类管理</el-divider>
        <div class="cal-tas-search-con">
            <!-- <select-input :options="first_cate_options" value="source" label="label" placeholder="请选择分类"
                controller="\App\Controller\Qyh\CallTaskController" method="list" :host="hyperfHost"
                @createSearch="createSearch" /> -->
            <el-button type="primary" size="mini" @click="openTypeinDrawer('录入')"
                style="margin-left: auto;">录入</el-button>
        </div>

        <el-table height="calc(100vh - 5.3rem)" :data="tableData" style="width: 100%" border size="mini"
            :header-cell-style="{
                background: '#ecf4ff',
                color: '#333',
                fontWeight: '900',
                fontSize: '0.28rem'
            }">
            <el-table-column prop="" label="序号" width="80">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="name" label="分类名称" align="center">
                <template slot-scope="scope">
                    {{ scope.row.name }}
                    <el-tooltip content="任务数量" placement="top" :open-delay=500>
                        <em :class=$style.resource_task_count>（{{ scope.row.pid == 0 ? '-' :
                            scope.row.resource_task_count
                            }}）</em>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="desc" label="备注信息" align="center">
            </el-table-column>
            <el-table-column prop="cate" label="所属分类" align="center">
                <template slot-scope="scope">
                    <el-tag type="warning" effect="dark" size="mini">
                        {{ scope.row.cate }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="" label="操作" align="center" width="180">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="编辑" placement="top">
                        <el-button type="primary" @click.native="openTypeinDrawer('编辑', scope.row)" size="mini"
                            icon="el-icon-edit" circle></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="scope.row.pid ? '建立任务' : '一级分类不能建立任务'" placement="top">
                        <el-button type="primary" @click.native="openTaskDrawer(scope.row)" size="mini"
                            icon="el-icon-plus" circle :disabled="!scope.row.pid"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="导出加密手机号" placement="top">
                        <el-button type="primary" @click.native="exportPhone(scope.row)" size="mini"
                            icon="el-icon-download" circle :disabled="!scope.row.pid"></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="外呼任务导出" placement="top">
                        <el-button type="primary" @click.native="exportOutCallTask(scope.row)" size="mini"
                            icon="el-icon-document" circle :disabled="!scope.row.pid"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align: right;">
            <pagination-com :total="total" :perPage="pageSize" :npage="npage" @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange" />
        </div>

        <el-drawer :visible.sync="typeInDrawer" direction="rtl" @beforeClose="handleClose_typein"
            @close="handleClose_typein_im" size="50%">
            <template slot="title">
                <span style="color: #409eff; font-size: medium; font-weight: bold">{{ typeInDrawer_title }}</span>
            </template>
            <div style="padding: 0.2rem 0.3rem;">
                <infinite-cate :el_card_title="el_card_title">
                    <template v-slot:content>
                        <el-form :model="cateForm" :rules="cateFormRules" ref="cateForm" label-width="90px">
                            <el-form-item label="选择分类:" prop="" style="line-height: 50px;">
                                <select-input :choosed="cate_choosed" @click.native="loadCate" :options="cate_options"
                                    value="id" label="name" placeholder="请选择分类" @createSearch="createSearch"
                                    :multiple="false" />
                                <div style="font-size: xx-small;color: #E6A23C; float: left;margin-top: -0.3rem;"><i
                                        class="el-icon-s-opportunity"></i>不选择分类视为一级分类</div>
                            </el-form-item>

                            <el-form-item label="分类名称:" prop="name" style="clear: both;">
                                <el-input v-model="cateForm.name" size="mini" maxlength="25" show-word-limit
                                    clearable></el-input>
                            </el-form-item>

                            <el-form-item label="备注:" prop="desc" style="clear: both;">
                                <el-input v-model="cateForm.desc" :autosize="{ minRows: 2, maxRows: 5 }" type="textarea"
                                    size="mini" maxlength="255" show-word-limit clearable></el-input>
                            </el-form-item>
                        </el-form>
                    </template>
                </infinite-cate>
                <div style="text-align: right;padding: 0.2rem 0;">
                    <el-button size="mini" type="primary" @click="submitForm('cateForm')">提
                        交</el-button>
                </div>
            </div>
        </el-drawer>

        <el-drawer :visible.sync="taskDrawer" direction="rtl" @beforeClose="handleClose_task"
            @close="handleClose_buildTask" size="50%" v-infinite-scroll="load">
            <template slot="title">
                <span style="color: #409eff; font-size: medium; font-weight: bold">创建任务</span>
            </template>
            <div style="padding: 0.2rem 0.3rem;">
                <build-task :id="taskDrawer_id" :first_level="first_level" :second_level="second_level"
                    @builded="builded" />
            </div>
        </el-drawer>

        <el-drawer :visible.sync="exportOutCallTaskDrawer" direction="rtl" @beforeClose="beforeHandleClose_exportOutCallTask"
            @close="handleClose_exportOutCallTask" size="50%" v-infinite-scroll="load">
            <template slot="title">
                <span style="color: #409eff; font-size: medium; font-weight: bold">外呼任务导出</span>
            </template>
            <!-- <div style="padding: 0.2rem 0.3rem;"> -->
            <export-out-call-task v-if="exportOutCallTaskDrawer" :cate_id="cate_id" :cate_name="prop_cate_name"/>
            <!-- </div> -->
        </el-drawer>
    </div>
</template>

<script>
import InfiniteCate from '../../commonReform/InfiniteCate'
import SelectInput from '../../commonReform/SelectInput';
import PaginationCom from '../../commonReform/PaginationCom';
import BuildTask from './Components/BuildTask.vue';
export default {
    name: 'CateManage',
    components: { InfiniteCate, SelectInput, PaginationCom, BuildTask, 
        'export-out-call-task': () => import('@/pages/cloudClue/Components/ExportOutCallTask')
    },
    data() {
        return {
            typeInDrawer: false,
            typeInDrawer_title: '',
            cateForm: {
                name: '',
                pid: '',
                desc: ''
            },
            cateForm_edit_id: null,
            cateFormRules: {
                name: [
                    { required: true, message: '请输入分类名称', trigger: 'blur' },
                    { max: 25, message: '最多25个字符', trigger: 'blur' }
                ]
            },
            cate_options: [],
            tableData: [],
            cate_choosed: null,
            el_card_title: '',
            taskDrawer: false,
            taskDrawer_id: null,
            pageSize: 30,
            total: 0,
            npage: 1,
            first_level: '',
            second_level: '',
            exportOutCallTaskDrawer: false,
            cate_id: null,
            prop_cate_name: ''
        }
    },
    methods: {
        openTypeinDrawer(title, row) {
            this.typeInDrawer_title = title
            this.typeInDrawer = true
            if (title === '编辑') {
                this.el_card_title = '修改信息'
                this.cate_choosed = row.pid
                this.cateForm.name = row.name
                this.cateForm.pid = row.pid
                this.cateForm.desc = row.desc
                this.cate_options = [{ id: row.pid, name: row.cate }]
                this.cateForm.id = row.id
            } else if (title === '录入') {
                this.el_card_title = '添加分类'
            }
        },
        openTaskDrawer(row) {
            this.taskDrawer_id = row.id
            this.first_level = row.cate
            this.second_level = row.name
            this.taskDrawer = true
        },
        clearData() {
            this.typeInDrawer_title = ''
            this.cate_options = []
            this.cate_choosed = null
            this.el_card_title = ''
            this.cateForm = this.$options.data().cateForm
        },
        handleClose_typein(done) {
            this.$confirm('确定关闭吗？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        handleClose_task(done) {
            this.$confirm('确定关闭吗？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        handleClose_typein_im() {
            this.clearData()
        },
        handleClose_buildTask() {
            this.clearDataTask()
        },
        clearDataTask() {
            this.taskDrawer_id = null
        },
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$axios
                        .post('api/api3_call_task/cate_store', this.cateForm)
                        .then(({ data }) => {
                            if (data.code === 0) {
                                this.typeInDrawer = false
                                this.loadTable()
                                this.$message.success(data.msg)
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                        .catch()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        loadTable() {
            this.$axios.get(`api/api3_call_task/load_table?page=${this.npage}`, {
                loadingClose: true, params: {
                    perPage: this.pageSize,
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.tableData = data.data.data
                    this.total = data.data.total
                }
            }).catch()
        },
        createSearch(val) {
            this.cate_choosed = val
            this.cateForm.pid = val
        },
        loadCate() {
            this.$axios.get('api/api3_call_task/load_cate', { loadingClose: true, }).then(({ data }) => {
                if (data.code === 0) {
                    this.cate_options = data.data
                }
            }).catch()
        },
        handleSizeChange(val) {
            this.npage = 1;
            this.pageSize = val;
            this.loadTable();
        },
        handleCurrentChange(val) {
            this.npage = val;
            this.loadTable();
        },
        builded() {
            this.taskDrawer = false
        },
        exportPhone(row) {
            this.$axios.post('api/api3_call_task/export_phone', {
                id: row.id
            }, { responseType: 'blob' }).then(({ data }) => {
                if (data.type === 'application/json') {
                    // console.log(data,'data')
                    const reader = data.text();
                    reader.then(text => {
                        const d = JSON.parse(text);
                        this.$message.warning(d.msg)
                        // 现在你可以处理你的数据了
                    });
                    return false
                }
                // 创建一个新的URL代表指定的File对象或Blob对象
                const url = window.URL.createObjectURL(new Blob([data]));
                // 创建一个a标签用于触发下载
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${row.name}.csv`);
                document.body.appendChild(link);
                link.click();
                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }).catch()
        },
        load() {

        },
        exportOutCallTask(row) {
            this.cate_id = row.id
            this.prop_cate_name = row.name
            this.exportOutCallTaskDrawer = true
        },
        clearData_exportOutCallTask () {
            this.cate_id = null
            this.prop_cate_name = ''
        },
        beforeHandleClose_exportOutCallTask(done) {
            this.$confirm('确定关闭吗？')
                .then(_ => {
                    this.clearData_exportOutCallTask()
                    done();
                })
                .catch(_ => { });
        },
        handleClose_exportOutCallTask() {
        },
    },
    mounted() {
        this.loadTable()
    }
}
</script>

<style scoped>
.cate-manage {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.cate-manage .cal-tas-search-con {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
}

.el-drawer__wrapper>>>.el-drawer {
    overflow-y: auto;
}
</style>

<style module>
.resource_task_count {
    margin-left: 0.2rem;
    color: #409EFF;
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/CateManage.vue